/* Standard Shopify product form adapter; disabled together with managed routing. */
(() => {
  if (!window.SCB_CONFIG?.enabled) return;
  function adapt() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (!form.querySelector('[name="id"]') || form.querySelector('[data-scb-buy-now]')) return;
      const add = form.querySelector('[name="add"],button[type="submit"],input[type="submit"]');
      if (!add) return;
      const button = document.createElement('button');
      button.type = 'button'; button.className = add.className;
      button.dataset.scbBuyNow = ''; button.textContent = 'Buy now';
      button.style.marginTop = '10px'; button.style.width = '100%';
      add.insertAdjacentElement('afterend', button);
    });
  }
  adapt(); new MutationObserver(adapt).observe(document.body, {childList:true,subtree:true});
})();
